import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import {
    Modal, Fab, Typography,
    Divider, List, ListItem
} from "@material-ui/core";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import Popover from '@material-ui/core/Popover';
import { createMarkup } from "../common";

export const LabsComponent = props => {    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [_labs, setLabs] = useState(false);
    const [_abbrvs, setAbbrs] = useState(false);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleFABClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFABClose = () => {
        setLabs(false);
        setAbbrs(false);
        setAnchorEl(false);
    }

    const open = Boolean(anchorEl);
    const labs = Boolean(_labs);
    const abbrvs = Boolean(_abbrvs);

    const _restTest = (obj) => {
        if (navigator.notification) {
            function onConfirm (index) {
                index = Number(index);

                switch (index) {
                    case 1: {
                        props.resetDeck(obj);
                        return handleFABClose();
                        break;
                    }
                    default: {
                        return handleFABClose();
                        break;
                    }
                }
            }

            let str = 'test';
            if (props.gamemode === 3 || props.gamemode === 4) { str = 'deck'; }

            navigator.notification.confirm(
                `Are you sure that you want to reset this ${str}?`,
                onConfirm,
                'SASP'
            );

            if (typeof obj.deckid === 'undefined') {
                return {pathname: '/home'}
            } else {
                return {pathname: '/myDecks'}
            }
        } else {
        }
    }

    const openModal = (type) => {
        setLabs(false);
        setAbbrs(false);

        switch(type) {
            case 'labs': {
                setLabs(true);
                break;
            }
            case 'abbrvs': {
                setAbbrs(true);
                break;
            }
        }
    }

    if (props.labs.hasLabs) {
        let modalStyle = {
            display:"flex",
            flexDirection:"column",
            justifyContent:"flex-start",
            alignItems:"flext-start",
            backgroundColor:"white",
            width:"90vw",
            maxHeight:"83vh",
            minHeight:"50vh",
            margin:"5vh 5vw",
            border:"2px solid #00567a",
            borderRadius:"4px",
            outline: "none",
            overflow: "auto",
        };

        let tableCSS = {
            margin: "16px 2px",
            width: "calc(100% - 4px)",
            border: "1px solid rgba(0,0,0,0.16)",
            borderRadius: "4px",
            boxShadow: "2px 4px 6px rgba(0,0,0,0.25)",
            overflow: "hidden"
        }

        let fabCSS = {
            marginLeft: "8px", 
            color: "rgb(152, 152, 152)", 
            backgroundColor:"rgb(229, 240, 223)"
        }
        
        let __labs = {gc: [], endocrine: [], abg: []};
        let __abbrvs = [];

        if (props.year && props.year > 2011) {
            __labs.gc = props.labs.labs.gc.filter(item => item.year === Number(props.year));
            __labs.endocrine = props.labs.labs.endocrine.filter(item => item.year === Number(props.year));
            __labs.abg = props.labs.labs.abg.filter(item => item.year === Number(props.year));

            __abbrvs = props.labs.abbrvs.filter(item => item.year === Number(props.year));
        } else {
            __labs.gc = props.labs.labs.gc.filter(item => item.year === 2020);
            __labs.endocrine = props.labs.labs.endocrine.filter(item => item.year === 2020);
            __labs.abg = props.labs.labs.abg.filter(item => item.year === 2020);

            __abbrvs = props.labs.abbrvs.filter(item => item.year === 2020);
        } 

        return (
            <>
                <>
                    <Fab 
                        id={'Labs-FAB'}
                        size="small"
                        style={fabCSS}
                        open={open}
                        onClick={handleFABClick}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <MoreHorizIcon />
                    </Fab>
                    <Popover
                        id={'Labs-Popover-DIV'}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <List dense={true}>
                            <ListItem>
                                <Link onClick={() => openModal('abbrvs')} className="text-blue">
                                    Abbreviations
                                </Link>

                                <Modal
                                    open={abbrvs}
                                    onClose={handleFABClose}
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    // style={modalStyle}
                                >
                                    <div style={modalStyle}>
                                        <div className="padding-right-16 padding-left-16">
                                            <Typography className="homeDividerText margin-top-8">Abbreviations</Typography>
                                            <Divider className="SASPTestsDivider"  style={{margin: "0", width: "100%"}}/>

                                            <TableContainer>
                                                <Table style={tableCSS}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Abbreviation</TableCell>
                                                            <TableCell>Value</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {__abbrvs.map((row) => (
                                                            <TableRow>
                                                                <TableCell dangerouslySetInnerHTML={createMarkup(row.text)} className="padding-top-4 paddin-bottom-4"/>

                                                                <TableCell      
                                                                    dangerouslySetInnerHTML={createMarkup(row.value)} className="padding-top-4 paddin-bottom-4"/>
                                                            </TableRow>
                                                        ))}
                                                        
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        
                                        </div>
                                    </div>
                                </Modal>
                            </ListItem>

                            <ListItem>
                                <Link onClick={() => openModal('labs')} className="text-blue">
                                    Normal Lab Values
                                </Link>
                                <Modal
                                    open={labs}
                                    onClose={handleFABClose}
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    // style={modalStyle}
                                >
                                    <div style={modalStyle}>
                                        <div className="padding-right-16 padding-left-16">
                                            <Typography className="homeDividerText margin-top-8">Normal Lab Values</Typography>
                                            <Divider className="SASPTestsDivider"  style={{margin: "0", width: "100%"}}/>

                                            <TableContainer>
                                                <Table style={tableCSS}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Abbreviation</TableCell>
                                                            <TableCell>Value</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow >
                                                            <TableCell colspan={2} className="text-blue text-strong">General Chemistry</TableCell>
                                                        </TableRow>
                                                        {__labs.gc.map((row) => (
                                                            <TableRow>
                                                                <TableCell dangerouslySetInnerHTML={createMarkup(row.text)} className="padding-top-4 paddin-bottom-4"/>

                                                                <TableCell      
                                                                    dangerouslySetInnerHTML={createMarkup(row.value)} className="padding-top-4 paddin-bottom-4"/>
                                                            </TableRow>
                                                        ))}

                                                        <TableRow >
                                                            <TableCell colspan={2} className="text-blue text-strong">Endocrine</TableCell>
                                                        </TableRow>
                                                        {__labs.endocrine.map((row) => (
                                                            <TableRow>
                                                                <TableCell dangerouslySetInnerHTML={createMarkup(row.text)} className="padding-top-4 paddin-bottom-4"/>

                                                                <TableCell      
                                                                    dangerouslySetInnerHTML={createMarkup(row.value)} className="padding-top-4 paddin-bottom-4"/>
                                                            </TableRow>
                                                        ))}
                                                        
                                                        <TableRow >
                                                            <TableCell colspan={2} className="text-blue text-strong">Arterial Blood Gases</TableCell>
                                                        </TableRow>
                                                        {__labs.abg.map((row) => (
                                                            <TableRow>
                                                                <TableCell dangerouslySetInnerHTML={createMarkup(row.text)} className="padding-top-4 paddin-bottom-4"/>

                                                                <TableCell      
                                                                    dangerouslySetInnerHTML={createMarkup(row.value)} className="padding-top-4 paddin-bottom-4"/>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        
                                        </div>
                                    </div>
                                </Modal>
                            </ListItem>
                        
                            {props.gamemode === 1 || props.gamemode === 2
                                ? (
                                    <ListItem>
                                        <Link 
                                            onClick={() => {
                                                const _redirect = _restTest({
                                                    mcid: props.mcid,
                                                    key: props.mykey,
                                                    yearvar: props.year,
                                                    gameMode: props.gamemode
                                                })
                                                return null
                                            }} 
                                            className="text-blue"
                                        >
                                            Reset Test
                                        </Link>
                                    </ListItem>
                                ) : null
                            }

                            {props.gamemode === 3 || props.gamemode === 4
                                ? (
                                    <ListItem>
                                        <Link 
                                            onClick={() => {
                                                _restTest({
                                                    mcid: props.mcid,
                                                    key: props.mykey,
                                                    deckID: props.deckID,
                                                    gameMode: props.gamemode
                                                })
                                                return <Redirect to={'/myDecks'} />
                                            }} 
                                            className="text-blue"
                                        >
                                            Reset Deck
                                        </Link>
                                    </ListItem>
                                ) : null
                            }
                        </List>
                    </Popover>
                </>                
            </>
        )
    } else {
        return (<></>)
    }
}